/* eslint-disable react/jsx-no-target-blank */
import React from "react";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import { MdLibraryAdd } from "react-icons/md";
import { apiPath, RoutePath } from "../../utility/Constant";
import { deleteData } from "../../hooks/delete";
import { useState } from "react";

const ClientsCard = ({ project, user, indexId }) => {
  const [hidden, setHidden] = useState(false);
  const { addClients } = RoutePath;
  const { clientsApi } = apiPath;

  const handleDelete = (event) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes!",
    }).then((result) => {
      if (result.isConfirmed) {
        deleteData(`${clientsApi}/${indexId}`, { id: event.target.id });
        setTimeout(() => {
          setHidden(true);
        }, 1000);
      }
    });
  };

  return (
    <div className={hidden && "hidden"}>
      {project ? (
        <div className="card bg-base-100 shadow-xl h-[20rem] rounded-md">
          <figure className="block h-[100%]">
            <img
              src={project.url}
              alt={project.title + " " + "Image"}
              className="min-h-[275px] object-contain w-full"
            />
          </figure>

          <div className="p-3 h-full flex flex-col justify-between">
            <h2 className="text-xl text-center uppercase font-semibold">
              {project.title}
            </h2>

            <div className="card-actions justify-between">
              <Link
                to={`/clients/${project._id}`}
                className="btn btn-outline btn-xs border-blue-500 text-blue-500 hover:bg-blue-500 hover:border-blue-500 hover:text-white rounded-md h-8 "
              >
                Edit
              </Link>
              {user === "admin" && (
                <button
                  id={project._id}
                  onClick={handleDelete}
                  className="btn btn-outline btn-xs border-red-500 text-red-500 hover:bg-red-500 hover:border-red-500 hover:text-white rounded-md h-8 "
                >
                  Delete
                </button>
              )}
            </div>
          </div>
        </div>
      ) : (
        <Link to={`/${addClients}`}>
          <div className="flex justify-center items-center h-[20rem] rounded-xl bg-gray-50 shadow-xl">
            <p className="text-8xl">
              <MdLibraryAdd />
            </p>
          </div>
        </Link>
      )}
    </div>
  );
};

export default ClientsCard;
